import { NoteMilestone } from '@monetize/types/app';
import { FunctionComponent as FC } from 'react';
import { MDivider, MFlex, MTag } from '../Monetize';
import { DateDisplay } from '../Monetize/DateDisplay';

interface NoteMilestoneDisplayProps {
  milestone: NoteMilestone;
}

export const NoteMilestoneDisplay: FC<NoteMilestoneDisplayProps> = ({
  milestone,
}: NoteMilestoneDisplayProps) => {
  return (
    <MFlex alignItems="center">
      <MDivider color="tGray.back" />
      <MTag size="md" variant="mileStone">
        {milestone.label} -{' '}
        <DateDisplay
          as="span"
          date={milestone.date}
          textProps={{ ml: 1, color: 'inherit', fontSize: 'inherit' }}
          timezoneConfigKey="userTimezone"
        />
      </MTag>
      <MDivider color="tGray.back" />
    </MFlex>
  );
};
